<template>
  <div class="column4-container">
    <Header></Header>
    <Center></Center>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Center from './components/Center.vue'
import Foot from './components/Foot.vue'
export default {
  components: {
    Header,
    Center,
    Foot
  },

  data () {
    return {
      
    }
  },

  mounted () {
    
  },

  methods: {
    
  },
}
</script>

<style lang="less" scoped>
.column4-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 648px;
}
</style>